import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CustomDialog } from 'components/shared/Dialog/CustomDialog';
import { MatchedRecordDetailsCard } from './MatchedRecordDetailsCard';

interface Props {
  isOpen: boolean;
  submitting: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  matchConfidence: number | null;
  vendorOpportunityId: string | null;
  applicantName: string | null;
  contactName: string | null;
  equipmentDescription: string | null;
  requestedAmount: number | null;
  dealerName: string | null;
}

export const AddSubmissionToExistingOpportunityModal = ({
  isOpen,
  submitting,
  onClose,
  onConfirm,
  matchConfidence,
  vendorOpportunityId,
  applicantName,
  contactName,
  equipmentDescription,
  requestedAmount,
  dealerName,
}: Props) => (
  <CustomDialog
    isOpen={isOpen}
    onClose={onClose}
    label="Add Submission to Existing Opportunity"
    actions={
      <>
        <Button variant="outlined" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={submitting}>
          Create Submission
        </Button>
      </>
    }
  >
    <Stack spacing={2}>
      <Typography variant="body1">
        A matching opportunity was found. A new submission will be added to this opportunity using the confirmed
        application data.
      </Typography>

      <MatchedRecordDetailsCard
        sectionLabel="Matched Opportunity"
        matchConfidence={matchConfidence}
        linkUrl={vendorOpportunityId ? `/vo/${vendorOpportunityId}` : null}
        applicantName={applicantName}
        contactName={contactName}
        equipmentDescription={equipmentDescription}
        requestedAmount={requestedAmount}
        dealerName={dealerName}
      />
    </Stack>
  </CustomDialog>
);
